<div
  class="flex-column"
  style="overflow: auto; height: 100%; max-width: 1400px; padding-top: 5px"
  [formGroup]="form"
>
  <mat-form-field
    appearance="outline"
    (focusout)="changeDescription()"
  >
    <mat-label>Prüfnotiz</mat-label>

    <input
      matInput
      formControlName="description"
      [readonly]="isReadOnly"
    >
  </mat-form-field>

  <div class="flex-row" style="padding: 5px; gap: 5px; align-items: center">
    <mat-slide-toggle
      labelPosition="before"
      [formControl]="form.controls.active"
      [disabled]="isReadOnly"
      style="display: flex; align-items: center"
      (change)="changeActive()"
    >
      <span style="font-size: 10pt">aktiv</span>
    </mat-slide-toggle>

    <button
      mat-raised-button
      color="warn"
      (click)="deleteTestrule(); $event.stopPropagation()"
      [disabled]="isReadOnly"
    >
      Löschen
    </button>

    <button
      mat-raised-button
      color="accent"
      (click)="duplicateTestrule(); $event.stopPropagation()"
      [disabled]="isReadOnly"
    >
      Duplizieren
    </button>
  </div>

  @if (query() && modifiedRepository() && formValue().selected) {
    <div style="position: relative;">
      <ejs-querybuilder
        width="70%"
        locale="de"
        (change)="onQueryChanged($event)"
        [separator]="separator"
        [columns]="modifiedRepository()"
        [rule]="query()"
      >
      </ejs-querybuilder>

<!--      Overlay preventing interactions, since readonly property of ejs-querybuilder isn't working properly-->
      @if (isReadOnly) {
        <div style="
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         z-index: 1000;
         background: transparent;
        ">
        </div>
      }
    </div>
  }
</div>
